import React, { Suspense } from "react";


const withSuspense = (Component, load, props = {}) => {

  return (
    <Suspense fallback={load}>
      <Component {...props} />
    </Suspense>
  )
}

export default withSuspense